<!-- Skeleton con la misma rejilla que la vista: sin hueco reservado, la página crece de golpe al
     llegar las gráficas y empuja lo que se estaba mirando. -->
<div class="mx" *ngIf="loading" aria-busy="true" aria-label="Calculando métricas">
  <div class="mx-kpis">
    <div class="mx-card kpi" *ngFor="let k of [1, 2, 3, 4]">
      <p-skeleton height="0.8rem" width="7rem"></p-skeleton>
      <p-skeleton height="1.9rem" width="4.5rem"></p-skeleton>
      <p-skeleton height="0.65rem" width="9rem"></p-skeleton>
    </div>
  </div>
  <div class="mx-row mx-row--8-4">
    <div class="mx-card sk-chart">
      <p-skeleton height="0.9rem" width="12rem"></p-skeleton><p-skeleton height="260px" borderRadius="10px"></p-skeleton>
    </div>
    <div class="mx-card sk-chart">
      <p-skeleton height="0.9rem" width="9rem"></p-skeleton><p-skeleton height="260px" borderRadius="10px"></p-skeleton>
    </div>
  </div>
</div>

<div class="mx-state" *ngIf="!loading && failed">
  <i class="fa-solid fa-chart-line" aria-hidden="true"></i>
  <p>No se pudieron cargar las métricas.</p>
  <button
    pButton
    type="button"
    class="p-button-sm p-button-outlined"
    label="Reintentar"
    [loading]="retrying"
    [disabled]="retrying"
    (click)="retry()"
  ></button>
</div>

<div class="mx" *ngIf="!loading && vm as v">
  <!-- ═══ A · KPIs ═══ -->
  <div class="mx-kpis">
    <div
      class="mx-card kpi"
      *ngFor="let k of v.kpis; trackBy: trackByKey"
      [attr.data-tone]="k.tone"
      [pTooltip]="k.hint"
      tooltipPosition="top"
      tabindex="0"
      [attr.aria-describedby]="'kpi-hint-' + k.key"
    >
      <div class="kpi-top">
        <span class="kpi-icon" [attr.data-accent]="k.accent"><i [class]="k.icon" aria-hidden="true"></i></span>
        <span class="kpi-label">{{ k.label }}</span>
      </div>
      <div class="kpi-value">
        {{ k.value }}<span class="kpi-unit" *ngIf="k.unit">{{ k.unit }}</span>
      </div>
      <div
        class="kpi-meter"
        *ngIf="k.meter !== null"
        role="progressbar"
        [attr.aria-label]="k.label"
        [attr.aria-valuenow]="k.meter"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <span [style.width.%]="k.meter"></span>
      </div>
      <div class="kpi-sub">{{ k.sub }}</div>
      <!-- La explicación del tooltip, también para teclado y lector de pantalla. -->
      <span class="sr-only" [id]="'kpi-hint-' + k.key">{{ k.hint }}</span>
    </div>
  </div>

  <!-- ═══ B · Velocidad + sprint en curso ═══ -->
  <div class="mx-row mx-row--8-4">
    <section class="mx-card mx-chart-card" aria-labelledby="mx-vel">
      <header class="mx-head">
        <span class="mx-head-icon i-green"><i class="fa-solid fa-chart-line" aria-hidden="true"></i></span>
        <div>
          <h3 id="mx-vel">Velocidad de TI</h3>
          <p>Puntos entregados por quincena</p>
        </div>
      </header>
      <ng-container *ngIf="v.velocity as vel; else noVelocity">
        <app-metric-chart [model]="vel.chart" [height]="240"></app-metric-chart>
        <div class="mx-legend">
          <span class="lg lg-line">Entregado</span>
          <span class="lg lg-projected">Comprometido del sprint en curso</span>
          <span class="lg lg-progress">Avance a hoy</span>
        </div>
        <p class="mx-caption">{{ vel.caption }}</p>
        <p class="mx-foot"><i class="fa-solid fa-circle-info" aria-hidden="true"></i> {{ vel.note }}</p>
      </ng-container>
      <ng-template #noVelocity><p class="mx-empty">Todavía no hay entregas que dibujar.</p></ng-template>
    </section>

    <section class="mx-card mx-chart-card" aria-labelledby="mx-sprint">
      <header class="mx-head">
        <span class="mx-head-icon i-blue"><i class="fa-solid fa-flag" aria-hidden="true"></i></span>
        <div>
          <h3 id="mx-sprint">{{ v.sprint?.title || 'Sprint en curso' }}</h3>
          <p *ngIf="v.sprint?.window">{{ v.sprint?.window }}</p>
        </div>
      </header>
      <ng-container *ngIf="v.sprint as s; else noSprint">
        <div class="sp-headline">
          <span class="sp-big">{{ s.delivered }}</span>
          <span class="sp-of">/ {{ s.committed ?? '—' }} pts</span>
          <span class="sp-pct" *ngIf="s.committed">{{ s.progress }}%</span>
        </div>
        <app-metric-chart *ngIf="s.chart; else noCurve" [model]="s.chart" [height]="150"></app-metric-chart>
        <ng-template #noCurve
          ><p class="mx-empty">{{ s.emptyText || 'El sprint acaba de arrancar: aún no hay curva.' }}</p></ng-template
        >
        <div class="mx-legend" *ngIf="s.chart">
          <span class="lg lg-line">Acumulado</span>
          <span class="lg lg-ideal">Ritmo ideal</span>
          <span class="lg lg-hline">Compromiso</span>
        </div>
        <ul class="sp-facts">
          <li *ngFor="let f of s.facts; trackBy: trackByIndex" [attr.data-tone]="f.tone">
            <i [class]="f.icon" aria-hidden="true"></i>
            <span class="k">{{ f.label }}</span>
            <span class="v">{{ f.value }}</span>
          </li>
        </ul>
      </ng-container>
      <ng-template #noSprint
        ><p class="mx-empty">No hay ningún sprint activo. Arranca uno para ver el avance de la quincena.</p></ng-template
      >
    </section>
  </div>

  <!-- ═══ C · En qué se invirtió ═══ -->
  <section class="mx-card" aria-labelledby="mx-inv">
    <header class="mx-head">
      <span class="mx-head-icon i-purple"><i class="fa-solid fa-layer-group" aria-hidden="true"></i></span>
      <div>
        <h3 id="mx-inv">En qué se invirtió</h3>
        <p>Puntos entregados por frente, tipo y origen</p>
      </div>
      <div class="mx-seg" role="group" aria-label="Periodo" *ngIf="v.investment.periods.length">
        <button
          type="button"
          *ngFor="let p of v.investment.periods; let i = index; trackBy: trackByKey"
          [class.on]="period === i"
          [attr.aria-pressed]="period === i"
          (click)="period = i"
        >
          {{ p.label }}
        </button>
      </div>
    </header>
    <div class="inv" *ngIf="v.investment.periods[period] as p; else noInvestment">
      <div class="inv-fronts">
        <div class="inv-total">
          <span class="big">{{ p.data.total }}</span
          ><span class="unit">pts</span>
        </div>
        <ul class="hbars">
          <li *ngFor="let r of p.data.fronts; trackBy: trackByKey">
            <span class="hb-label"><i class="hb-dot" [style.background]="r.color" aria-hidden="true"></i>{{ r.label }}</span>
            <span class="hb-track"><span [style.width.%]="r.width" [style.background]="r.color"></span></span>
            <span class="hb-val"
              >{{ r.valueLabel }}<small *ngIf="r.share"> · {{ r.share }}</small></span
            >
          </li>
        </ul>
        <p class="mx-foot" [class.warn]="p.data.estimatedPoints">{{ p.data.note }}</p>
      </div>
      <div class="inv-meters">
        <div class="meter" *ngFor="let mt of [p.data.type, p.data.origin]; trackBy: trackByIndex">
          <span class="meter-label">{{ mt.label }}</span>
          <div class="meter-bar" *ngIf="mt.total; else emptyMeter">
            <ng-container *ngFor="let sg of mt.segments; trackBy: trackByKey">
              <span *ngIf="sg.value" [style.width.%]="sg.pct" [style.background]="sg.color"></span>
            </ng-container>
          </div>
          <ng-template #emptyMeter><div class="meter-bar empty"></div></ng-template>
          <ul class="meter-keys">
            <li *ngFor="let sg of mt.segments; trackBy: trackByKey">
              <i [style.background]="sg.color" aria-hidden="true"></i>{{ sg.label }} <b>{{ sg.value }}</b> <small>{{ sg.pct }}%</small>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <ng-template #noInvestment><p class="mx-empty">Todavía no hay sprints con entregas que repartir.</p></ng-template>
  </section>

  <!-- ═══ D · Flujo ═══ -->
  <section class="mx-card" aria-labelledby="mx-flow">
    <header class="mx-head">
      <span class="mx-head-icon i-amber"><i class="fa-solid fa-hourglass-half" aria-hidden="true"></i></span>
      <div>
        <h3 id="mx-flow">Flujo del trabajo</h3>
        <p>Qué hay en cada etapa ahora y cuánto suele quedarse</p>
      </div>
    </header>
    <div class="flow-stages">
      <div class="stage" *ngFor="let st of v.flow.stages; trackBy: trackByIndex">
        <span class="stage-name"><i [class]="st.icon" [style.color]="st.color" aria-hidden="true"></i>{{ st.label }}</span>
        <span class="stage-now"
          >{{ st.now }}<small>{{ st.now === 1 ? 'tarea' : 'tareas' }} ahora</small></span
        >
        <span class="stage-old" [attr.data-tone]="st.oldestTone">la más antigua: {{ st.oldest }}</span>
        <span class="stage-avg">
          <span class="stage-avg-track"><span [style.width.%]="st.avgWidth" [style.background]="st.color"></span></span>
          <span
            >{{ st.avg }} <small>de permanencia · {{ st.samples }}</small></span
          >
        </span>
      </div>
    </div>
    <ol class="flow-steps">
      <li *ngFor="let sp of v.flow.steps; trackBy: trackByIndex">
        <span class="fs-val">{{ sp.value }}</span>
        <span class="fs-label">{{ sp.label }}</span>
        <span class="fs-detail">{{ sp.detail }}</span>
      </li>
    </ol>
    <p class="mx-foot" *ngIf="v.flow.total">
      <i class="fa-solid fa-circle-info" aria-hidden="true"></i> {{ v.flow.total }}. Cada tramo se mide sobre las tareas que tienen sus dos
      fechas, así que no suman exacto.
    </p>
  </section>

  <!-- ═══ E · Calidad ═══ -->
  <section class="mx-card" aria-labelledby="mx-bugs">
    <header class="mx-head">
      <span class="mx-head-icon i-red"><i class="fa-solid fa-shield-halved" aria-hidden="true"></i></span>
      <div>
        <h3 id="mx-bugs">Calidad</h3>
        <p>{{ v.quality.resolution }}</p>
      </div>
    </header>
    <div class="quality">
      <div class="q-chart">
        <span class="q-sub">Bugs reportados y resueltos por sprint</span>
        <app-metric-chart *ngIf="v.quality.chart; else noBugs" [model]="v.quality.chart" [height]="170"></app-metric-chart>
        <ng-template #noBugs><p class="mx-empty">Sin bugs registrados por sprint.</p></ng-template>
        <div class="mx-legend" *ngIf="v.quality.chart">
          <span class="lg" *ngFor="let l of v.quality.legend; trackBy: trackByIndex" [ngClass]="'lg-' + l.kind">{{ l.label }}</span>
        </div>
      </div>
      <div class="q-sev">
        <span class="q-sub">{{ v.quality.open }} abiertos, por severidad</span>
        <ul class="hbars">
          <li *ngFor="let r of v.quality.severity; trackBy: trackByKey">
            <span class="hb-label"
              ><i class="hb-dot" [class.dashed]="r.dashed" [style.background]="r.color" aria-hidden="true"></i>{{ r.label }}</span
            >
            <span class="hb-track"><span [class.dashed]="r.dashed" [style.width.%]="r.width" [style.background]="r.color"></span></span>
            <span class="hb-val">{{ r.valueLabel }}</span>
          </li>
        </ul>
      </div>
    </div>
  </section>

  <!-- ═══ F · Salud del dato ═══
       Un tablero que no dice qué no puede medir invita a leer sus números como si cubrieran todo. -->
  <section class="mx-card mx-health" aria-labelledby="mx-health">
    <header class="mx-head">
      <span class="mx-head-icon i-navy"><i class="fa-solid fa-clipboard-check" aria-hidden="true"></i></span>
      <div>
        <h3 id="mx-health">Salud del dato</h3>
        <p>Lo que a estos números todavía les falta</p>
      </div>
    </header>
    <div class="chips">
      <div class="chip" *ngFor="let c of v.health.chips; trackBy: trackByKey" [attr.data-tone]="c.tone">
        <span class="chip-v">{{ c.value }}</span>
        <span class="chip-k">{{ c.label }}</span>
        <button
          *ngIf="c.review"
          type="button"
          class="chip-btn"
          [attr.aria-expanded]="reviewOpen"
          aria-controls="mx-review"
          (click)="reviewOpen = !reviewOpen"
        >
          {{ reviewOpen ? 'Ocultar' : 'Revisar' }}
        </button>
      </div>
    </div>
    <ul class="review" id="mx-review" *ngIf="reviewOpen && v.health.pending.length">
      <li *ngFor="let it of v.health.pending; trackBy: trackByIndex">
        <button type="button" (click)="openDetail(it.id)">
          <span class="rv-code">{{ it.code }}</span>
          <span class="rv-title">{{ it.title }}</span>
          <span class="rv-detail">{{ it.detail }}</span>
          <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
        </button>
      </li>
    </ul>
  </section>
</div>

<!-- Detalle de la tarea (mismo modal del Mapa de trabajo): ahí se corrige el reparto. -->
<app-worklog-item-detail
  [(visible)]="detailVisible"
  [itemId]="detailId"
  [isDev]="isDev"
  (changed)="onDetailChanged()"
></app-worklog-item-detail>
